module.exports = __webpack_public_path__ + "static/media/wallet-onboarding-icon-three.217bb916.svg";